<div class="unruly-new-design-wrapper">
  <div nz-row nzJustify="space-around" nzAlign="middle" class="login-container">

    <div class="logo-wrapper">
      <company-logo-svg [fill]="'#FFFFFF'"></company-logo-svg>
    </div>

    <div class="welcome-msg">
      <a class="underlined-link-button font-icon-color-grey-iron-important font-icon-hover-color-primary-white-important"
         href="https://nexxen.com"
         target="_blank" rel="noopener noreferrer">
        <span>Learn more about Nexxen!</span></a>
    </div>

    <div class="card-wrapper">
      <nz-card>
        <div class="semibold-font font-size-large-header font-icon-color-primary-black margin-bottom-small">{{ authPageTitle }}</div>
        <router-outlet></router-outlet>
        <div class="auth-links">
          <a *ngIf="isShowLinkInForm('forgotPassword')"
             class="underlined-link-button"
             routerLink="/auth/password/request" id="password-link"><span>Forgot Password</span></a>
          <a *ngIf="isShowLinkInForm('resendEmail')"
             class="underlined-link-button"
             routerLink="/auth/email/resend" id="resend-link"><span>Resend Activation Email</span></a>
          <a *ngIf="isShowLinkInForm('login')"
             class="underlined-link-button"
             routerLink="/auth/login" id="login-link"><span>Sign In</span></a>
        </div>
      </nz-card>
    </div>


  </div>
  <nz-footer>
    <span>Copyright <em nz-icon nzType="copyright"></em> {{ year }} All rights reserved to <a class="underlined-link-button" target="_blank" href="https://nexxen.com/" rel="noopener noreferrer">Nexxen International</a> Ltd</span>
  </nz-footer>
</div>
